module.exports = __webpack_public_path__ + "static/img/2_5.db85638e.jpg";